import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CreateFootcareAssessment, EditFootcareAssessment } from '../Model/FootcareAssessment';
import { AllpatientsService } from '../services/allpatients.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
@Component({
  selector: 'app-footcare-assessment',
  templateUrl: './footcare-assessment.component.html',
  styleUrls: ['./footcare-assessment.component.css']
})
export class FootcareAssessmentComponent implements OnInit {

  @Output() headerTitle = new EventEmitter<string>();
  CreateAssessment: CreateFootcareAssessment = new CreateFootcareAssessment();
  currentSelected: any[];
  isAdmin : boolean = false;
  role:any
  AssessmentData:Array<any>= new Array();
  editmodel:EditFootcareAssessment = new EditFootcareAssessment()
  
  constructor(private patientService: AllpatientsService, private Toastr: ToastrService) { }

  ngOnInit() {
    this.CreateAssessment.IsActive = true;
    this.headerTitle.emit("Footcare Assessment");
    this.role = localStorage.getItem("role");
    this.isAdmin = true;
    this.patientService.getAllAssessment().subscribe(data=>{
      this.AssessmentData = data;
    },
    error=>{
      this.Toastr.error("Something went wrong on the server side !!!");
    });
  }

  create() {
    this.patientService.CreateAssessment(this.CreateAssessment).subscribe((resp) => {
      this.Toastr.success("New data added successfully");
      this.ngOnInit();
      this.currentSelected = [];
      this.CreateAssessment.AssessmentGrading='';
    },
      (error) => {
        this.Toastr.error("Something went wrong on the server side !!!");
      });
  }
  Update(){
    this.patientService.UpdateAssessment(this.editmodel).subscribe(resp=>{
      this.Toastr.success('Data Updated Successfully ');
      $("#editMedicineModal").modal("hide");
      this.ngOnInit();
    },err=>{
    });

  } 

  SelectedMedicineDetail(data){
    this.editmodel = data;
  } 

}
